import { ProductItem, SubscriptionItem, VoucherItem } from "@repo/apis/bag";
import { BagSdkMethod } from "../utils/method-initialiser";

type ProductItems = ProductItem[] | null;

type PublicGetProductsMethod = () => ProductItems;
type GetProductsMethod = BagSdkMethod<PublicGetProductsMethod>;

function isProductItem(
  item: ProductItem | SubscriptionItem | VoucherItem,
): item is ProductItem {
  return item.itemType === "Product";
}

export const getProductsInitialiser: GetProductsMethod =
  ({ state }) =>
  () => {
    const bag = state.getBag();
    if (!bag) return null;

    return bag.items.filter(isProductItem);
  };
